import { DragEvent, MouseEvent } from 'react'
import { IconProps } from '../Icon/index.js'
import { Style } from 'inlines'
import { KeyHintProps } from '../KeyHint/index.js'
import { Button } from '../Button/index.js'

type IconButtonProps = {
  icon: IconProps['variant']
  onClick?: (e: MouseEvent) => void
  disabled?: boolean
  size?: 'regular' | 'small' | 'tiny'
  color?: 'neutral' | 'red'
  toggled?: boolean
  loading?: boolean
  tooltip?: string
  keyHint?: KeyHintProps['hint']
  keyHintVisualOnly?: boolean
  keyHintTarget?: HTMLElement
  trailChevron?: 'up' | 'down' | 'left' | 'right'
  forceHover?: boolean
  draggable?: boolean
  onDragStart?: (e: DragEvent) => void
  onDragEnd?: (e: DragEvent) => void
  style?: Style
}

const IconButton = ({
  onClick,
  disabled,
  icon,
  toggled,
  loading,
  color = 'neutral',
  tooltip,
  size = 'regular',
  keyHint,
  keyHintVisualOnly,
  keyHintTarget,
  trailChevron,
  forceHover,
  style,
  ...dragProps
}: IconButtonProps) => {
  return (
    <Button
      leadIcon={icon}
      onClick={onClick}
      disabled={disabled}
      toggled={toggled}
      loading={loading}
      color={color}
      tooltip={tooltip}
      size={size}
      keyHint={keyHint}
      keyHintVisibility="none"
      forceHover={forceHover}
      style={style}
      variant="ghost"
      trailIcon={trailChevron ? `tiny-chevron-${trailChevron}` : null}
      {...dragProps}
    />
  )
}

export type { IconButtonProps }
export { IconButton }
